import { useSyncExternalStore } from "react";

// Bağlantı durumu: tarayıcı çevrimdışı mı, sunucuya üst üste 2 istek ulaşamadı mı
let state = { online: navigator.onLine !== false, serverDown: false, recovered: false };
let fails = 0;
let probe = null;
let hideTimer = null;
const subs = new Set();
const healthy = (s) => s.online && !s.serverDown;

function emit(patch) {
  const was = healthy(state);
  state = { ...state, ...patch };
  if (!was && healthy(state)) {
    state = { ...state, recovered: true };
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => { state = { ...state, recovered: false }; subs.forEach((f) => f()); }, 3000);
  }
  if (healthy(state)) { clearInterval(probe); probe = null; } else if (!probe) startProbe();
  subs.forEach((f) => f());
}

function startProbe() {
  probe = setInterval(() => {
    if (!navigator.onLine) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/ping`, { cache: "no-store" }).then(() => net.ok()).catch(() => {});
  }, 5000);
}

export const net = {
  ok: () => { fails = 0; if (state.serverDown || !state.online) emit({ serverDown: false, online: true }); },
  fail: () => { fails += 1; if (fails >= 2 && !state.serverDown) emit({ serverDown: true }); },
  blocked: () => !healthy(state),
};

window.addEventListener("online", () => emit({ online: true }));
window.addEventListener("offline", () => emit({ online: false }));

const subscribe = (f) => { subs.add(f); return () => subs.delete(f); };
export const useNet = () => useSyncExternalStore(subscribe, () => state);
export const useOffline = () => !healthy(useNet());
